const METRIC_UNITS: Record<string, string> = {
  tws: 'kts',
  twa: '°',
  twa_abs: '°',
  awa: '°',
  awa_abs: '°',
  aws: 'kts',
  twd: '°',
  vmg: 'kts',
  vmgpc: '%',
  bsp: 'kts',
  bsppc: '%',
  sog: 'kts',
  heel: '°',
  pitch: '°',
  rudder: '°',
  trim: '°',
  rot: '°/s',
  hdg: '°',
  cog: '°',
  sogc: 'kts',
};

const METRIC_LABEL_OVERRIDES: Record<string, string> = {
  vmc: 'VMC',
  cog: 'COG',
};

const collapseWhitespace = (value: string): string => value.trim().split(/\s+/u).join(' ');

export function formatMetricLabel(metric: string): string {
  if (!metric) {
    return '';
  }
  const override = METRIC_LABEL_OVERRIDES[metric];
  const defaultLabel = collapseWhitespace(metric.replaceAll('_', ' ')).toUpperCase();
  const base = override ?? defaultLabel;
  const unit = METRIC_UNITS[metric];
  return unit ? `${base} (${unit})` : base;
}

export function formatMetricLabelNoUnit(metric: string): string {
  if (!metric) {
    return '';
  }
  const override = METRIC_LABEL_OVERRIDES[metric];
  const defaultLabel = collapseWhitespace(metric.replaceAll('_', ' ')).toUpperCase();
  return override ?? defaultLabel;
}
